<section>
  <section class="heading" data-testid="active-state-title">
    <app-dot-pulse [variant]="vm.colourVariant" />
    <p class="body bold">Waiting for parts</p>
  </section>

  <p class="body mt-8" data-testid="spare-parts-message">{{ vm.message }}</p>
</section>
